// WS 2311820. The Customers-list Financing toggle (All / Pending / Paid). `counts` is the list's
// meta.financingCounts: how many are pending and paid, shown on those options when known.
const COUNT_STYLES = {
  pending: 'bg-warning-light text-warning-main',
  1: 'bg-success-light text-success-main',
}
const COUNT_KEYS = { pending: 'pending', 1: 'paid' }

const FinancingToggle = ({ options, value, counts, onChange }) => (
  <div className="ml-5 flex items-center gap-1 text-sm whitespace-nowrap" role="group" aria-label="Financing">
    <span className="mr-1 text-text-secondary">Financing</span>
    {options.map(([option, label]) => {
      const count = counts ? counts[COUNT_KEYS[option]] : undefined
      return (
        <button key={label} type="button" aria-pressed={value === option}
          onClick={() => onChange(option)}
          className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg border ${value === option ? 'bg-primary-main text-white border-primary-main' : 'border-divider text-text-primary'}`}>
          {label}
          {typeof count === 'number' && (
            <span className={`px-1.5 rounded-full text-[11px] font-bold ${COUNT_STYLES[option]}`}>{count}</span>
          )}
        </button>
      )
    })}
  </div>
)

export default FinancingToggle
